// Firma kartı PDF üreteci — Ayarlar > Firma Bilgileri sayfasından paylaşılabilir tek sayfa PDF.
// Mutabakat PDF'i ile aynı görsel dil: sol üstte logo + sağda başlık, iki panelli grid
// (İletişim & Banka), altta imza satırı ve indirilme tarihi.
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerTurkishFont } from "@/lib/pdfFont";

async function loadLogoDataUrl() {
  try {
    const res = await fetch("/plasper-logo.jpg");
    const blob = await res.blob();
    return await new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onloadend = () => resolve(r.result);
      r.onerror = reject;
      r.readAsDataURL(blob);
    });
  } catch { return null; }
}

function _fmtTR(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return String(iso);
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" });
}

export async function generateCompanyProfilePDF(company) {
  const doc = new jsPDF({ compress: true });
  await registerTurkishFont(doc);
  const logo = await loadLogoDataUrl();
  const w = doc.internal.pageSize.getWidth();

  // Üst şerit — logo + başlık
  if (logo) {
    try { doc.addImage(logo, "JPEG", 14, 12, 45, 15, undefined, "FAST"); } catch {}
  }
  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.text("FİRMA KARTI", 65, 20);
  doc.setFont(undefined, "normal");
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(`Düzenlenme Tarihi: ${_fmtTR(new Date().toISOString())}`, 65, 27);
  doc.setTextColor(0);

  // Ayraç çizgi
  doc.setLineWidth(0.5);
  doc.line(14, 34, w - 14, 34);

  // Firma ünvanı (büyük)
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  const nameLines = doc.splitTextToSize(company.name || "—", w - 28);
  let y = 42;
  nameLines.forEach((ln) => { doc.text(ln, 14, y); y += 6; });
  doc.setFont(undefined, "normal");

  // Kimlik ve iletişim tablosu
  const identityRows = [
    ["Vergi Dairesi", company.tax_office || "—"],
    ["Vergi No / VKN", company.tax_id || "—"],
    ["Adres", company.address || "—"],
    ["Telefon", company.phone || "—"],
    ["E-posta", company.email || "—"],
    ["Web Sitesi", company.website || "—"],
  ];
  autoTable(doc, {
    startY: y + 2,
    head: [["Kimlik & İletişim", ""]],
    body: identityRows,
    styles: { fontSize: 10, font: "Roboto", cellPadding: 2.5 },
    headStyles: { fillColor: [10, 10, 10], font: "Roboto", fontStyle: "bold", halign: "left" },
    columnStyles: {
      0: { cellWidth: 45, fontStyle: "bold" },
      1: { cellWidth: "auto" },
    },
  });

  // Banka bilgileri tablosu
  const bankRows = [
    ["Banka", company.bank || "—"],
    ["IBAN", company.iban || "—"],
  ];
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 6,
    head: [["Banka Bilgileri", ""]],
    body: bankRows,
    styles: { fontSize: 10, font: "Roboto", cellPadding: 2.5 },
    headStyles: { fillColor: [10, 10, 10], font: "Roboto", fontStyle: "bold", halign: "left" },
    columnStyles: {
      0: { cellWidth: 45, fontStyle: "bold" },
      1: { cellWidth: "auto", font: "Roboto" },
    },
  });

  // Alt not
  const noteY = doc.lastAutoTable.finalY + 12;
  doc.setFontSize(9);
  doc.setTextColor(90);
  doc.text(
    "Bu belge, tarafımızca hazırlanmış resmi bir firma tanıtım kartıdır.",
    14, noteY
  );
  doc.text(
    "Fatura kesimi, mutabakat ve iletişim için yukarıdaki bilgileri esas alabilirsiniz.",
    14, noteY + 5
  );
  doc.setTextColor(0);

  // Ünvan dosya adında güvenli
  const safe = (company.name || "firma")
    .toString().replace(/[^a-zA-Z0-9-_ğüşıöçİĞÜŞÖÇ ]/g, "").trim().replace(/\s+/g, "_") || "firma";
  const iso = new Date().toISOString().slice(0, 10);
  doc.save(`firma-karti_${safe}_${iso}.pdf`);
}
